import { AfterViewInit, Component, ElementRef, inject, Renderer2, ViewChild } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { take } from 'rxjs';
import { UserApiService } from './api/user-api.service';
import { NO_LOGIN_KEY, TOKEN } from './constants/storageKey';
import { LoginStatusService } from './services/login-status.service';
import { MesRecordsService } from './services/mes-records.service';
import { MobileSideService } from './services/mobile-side.service';
import { TipPopService } from './services/tip-pop.service';
import { UserCommonService } from './services/user-common.service';
import { PopInformComponent } from './share/uis/pop-inform/pop-inform.component';
import { getMobileOperatingSystem, judgeDevicePcOrMobile } from './utils/useDeviceCategory';
import { useRem } from './utils/useRem';
import { useUUID } from './utils/useUUID';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, PopInformComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {

  @ViewChild('aiDialogue') aiDialogue!: ElementRef<HTMLDivElement>

  public tp = inject(TipPopService)
  private mobSideServe = inject(MobileSideService)
  private mesRecordsServe = inject(MesRecordsService)
  private loginStatusServe = inject(LoginStatusService)
  private userCSer = inject(UserCommonService)
  private router = inject(Router)
  private userApi = inject(UserApiService)
  private renderer = inject(Renderer2)

  // 初始化基本数据内容
  constructor() {
    // 判断是否为无校验界面
    const isNotAuth = new URLSearchParams(window.location.search).get('auth')
    if (isNotAuth === 'false') {
      this.mesRecordsServe.getDiaListsByNotLogin(localStorage.getItem(NO_LOGIN_KEY))
      this._handleDeviceMobileOrPc(false, false)
      return
    }

    // 获取小程序携带的token
    const miniProgramToken = new URLSearchParams(window.location.search).get('token')
    if (miniProgramToken) {
      localStorage.setItem(TOKEN, miniProgramToken.split(' ')[1])
      this.loginStatusServe.isMiniProgram = true
    }

    let noLoginKey = localStorage.getItem(NO_LOGIN_KEY)
    if (localStorage.getItem(TOKEN)) {
      // 确保本地存有noLoginToken
      if (!noLoginKey) {
        noLoginKey = useUUID(0, 32)
        localStorage.setItem(NO_LOGIN_KEY, noLoginKey)
        this.mesRecordsServe.createDiaList(false, noLoginKey, useUUID(0, 16))
      }

      this.userApi.getUserInfoAPI().pipe(take(1)).subscribe(async res => {
        // 登录状态
        if (res) {
          // 调整登录状态
          this.userCSer.LOGIN_STATUS = true
          // 同步用户数据并设置当前联系人
          await this.userCSer.refreshUserInfo().then(() => {
            // 小程序无联系人
            if (!this.userCSer.contsInfo?.length) {
              this.tp.tipPop('当前小程序用户未添加任何联系人信息', 'warning')
              this.userCSer.LOGIN_STATUS = false
              this.mesRecordsServe.getDiaListsByNotLogin(noLoginKey)
              return
            }
            // 处理登录数据
            this.mesRecordsServe.getDiaListsByLogin(this.userCSer.userInfo!.wx_user_id)
          })
        } else {
          // 未登录状态
          this.mesRecordsServe.getDiaListsByNotLogin(noLoginKey)
        }
      })
    } else {
      this.mesRecordsServe.getDiaListsByNotLogin(noLoginKey)
    }

    this._handleDeviceMobileOrPc(!!miniProgramToken)
  }

  // 处理移动端首次加载时页面的高度适配
  ngAfterViewInit() {
    if (judgeDevicePcOrMobile()) {
      setTimeout(() => {
        this.renderer.setStyle(this.aiDialogue.nativeElement, 'height', window.innerHeight + 'px')
      }, 500)
    }
  }

  // 跳转至移动/PC端界面
  private async _handleDeviceMobileOrPc(isMiniProgram: boolean, auth: boolean = true) {
    const isMobile = judgeDevicePcOrMobile()
    if (!auth || isMobile || (isMiniProgram && !isMobile)) {
      // 处理键盘事件，判断是IOS还是Android
      this.mobSideServe.renderer = this.renderer
      const isIOS = getMobileOperatingSystem() === 'ios'
      isIOS ? this.mobSideServe.IOSKeyboardAdaption() : this.mobSideServe.AndroidKeyboardAdaption()
      this.router.navigateByUrl(!auth ? 'not-auth-dialogue?auth=false' : 'dialogue', { replaceUrl: true })
    } else {
      new useRem()
      this.router.navigateByUrl('pc-dialogue', { replaceUrl: true })
    }
  }

}